import axios, {AxiosResponse} from 'axios'
// import {SAMPLE_REGISTER_RESPONSE} from './sampleResponse'
const API_URL = process.env.REACT_APP_THEME_API_URL
export interface transformedData {
  records: transformedRecord[]
  totalSales?: number | null
  currency?: string | null
  totalCredit: number | null
  totalDebit: number | null
}
const transformRegisterData = (data: RegisterResponse): transformedData => ({
  records: data.records.map(
    (_: Record): transformedRecord => ({
      transactionId: _.transaction_id,
      voucherName: _.voucher_name,
      voucherDate: _.voucher_date,
      voucherType: _.voucher_type,
      ledgerId: _.ledger_id,
      parentLedger: _.parent_ledger,
      subLedger: _.sub_ledger,
      particulars: _.sub_ledger ? `${_.parent_ledger} - ${_.sub_ledger}` : _.parent_ledger,
      voucherNumber: _.voucher_number,
      debit: _.debit,
      credit: _.credit,
    })
  ),
  totalSales: data.total_amount,
  currency: data.currency_code,
  totalCredit: data.total_credit,
  totalDebit: data.total_debit,
})

export interface transformedRecord {
  transactionId: number | null
  voucherName: string | null
  voucherDate: string
  voucherType: string | null
  ledgerId: number | null
  parentLedger: string
  subLedger: string | null
  particulars: string
  voucherNumber: number
  debit: number | null
  credit: number | null
}
export interface Record {
  transaction_id: number | null
  voucher_name: string | null
  voucher_date: string
  ledger_id: number | null
  voucher_type: string | null
  parent_ledger: string
  sub_ledger: string | null
  voucher_number: number
  debit: number | null
  credit: number | null
}

export interface RegisterResponse {
  records: Record[]
  total_amount?: number | null
  currency_code?: string | null
  total_credit: number | null
  total_debit: number | null
  // fromDate: string
  // toDate: string
  // credit: number
  // debit: number
  // closingBalance: number
}

export const getRegisterValues = async (
  report_type: string,
  company_id: number,
  fy_name: string,
  from_date: string,
  to_date: string
  // period: string
): Promise<transformedData | undefined> => {
  try {
    // return transformRegisterData(SAMPLE_REGISTER_RESPONSE)
    const response = await axios.post(
      `${API_URL}/accounting/transaction/report/register/`,
      {
        company_id,
        fy_name,
        from_date,
        to_date,
        report_name: 'register',
        report_type,
        // period,
      },
      {validateStatus: () => true}
    )
    if (!response) {
      throw new Error('Internal Server Error')
    }

    if (response.data && response.data.status && response.data.status === 'error') {
      throw new Error(response.data.message)
    }
    return transformRegisterData(response.data)
  } catch (err: any) {
    if (err) throw err
  }
}
